import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Observable } from '../../node_modules/rxjs';
import { EventEmitter } from 'events';

// const socketURL = 'ws://www.ask4token.com:1707';
const socketURL = 'wss://www.ask4token.com:1707';

@Injectable()

export class SocketclientService {
  ws: WebSocket;
  constructor() {
    this.ws = new WebSocket(socketURL);
  }

  public WebSocketMessage(): Observable<String> {
    return new Observable(observal => { 
      this.ws.onmessage = (event) => observal.next(event.data);
      this.ws.onerror = (event) => observal.error(event);
      this.ws.onclose = (event) => observal.complete();
      this.ws.onopen = (event) => observal.next();
    });
  }

  public WebSocketConnected(): Observable<String> {
    return new Observable(observal => { 
      this.ws.onerror = (event) => observal.error(event);
      this.ws.onclose = (event) => observal.complete();
      this.ws.onopen = (event) => observal.next();
    });
  }

  public WebSocketDisconnected(): Observable<String> {
    return new Observable(observal => { 
      this.ws.onerror = (event) => observal.error(event);
      //this.ws.onclose = (event) => observal.complete();
      this.ws.onclose = (event) => observal.next();
    });
  }

  retryConnection() {
    setTimeout(() => {
      this.ws = new WebSocket(socketURL);
    }, 8000);
  }

  retry(message: any) {
    console.log("again send");
    setTimeout(() => {
      this.send(message);
    }, 1000);
  }

  send(message: any) {
    if (this.ws.readyState === this.ws.OPEN) {
      this.ws.send(message);
    } else if (this.ws.readyState === this.ws.CLOSED) {
      console.log('Closed now opening process');
      this.retryConnection();
    } else {
      this.retry(message);
    }
  }
}
